export const contactsData = {
    email: 'kartikeyagarg07@gmail.com',

    sheetAPI: ''
}